module.exports = __webpack_public_path__ + "static/img/5.cab6abe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/saas/5.png
// module id = +ZQP
// module chunks = 1